<template>
  <v-app v-if="user" class="main-cont">
     <div>
      <v-app-bar
      color="transparent"
      dense
    >
      <v-spacer/>
      <v-btn icon  @click="logout()">
        <v-icon color="indigo">mdi-logout</v-icon>
      </v-btn>
  </v-app-bar>
     </div>
    <!-- timer for bookings -->
     <v-snackbar v-model="snackbar" :color="color" top :timeout="5000">
          <v-row justify="space-between">
            {{ text }}
            <v-btn
              dark
              icon
              @click="snackbar = false"
            >
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-snackbar>
    <overlay v-if="($store.state.flightsTimeOut && tab === 0) || ($store.state.carsTimeOut && tab === 1) || ($store.state.hotelTimeOut && tab === 2)"/>
    <v-card elevation="0" class="bg">
      <v-tabs
      v-model="tab"
      background-color="transparent"
      color="indigo"
      class="tabs"
      v-show="false"
      >
        <v-tab
          v-for="item in items"
          :key="item.title"
        >
          <v-icon left>{{item.icon}}</v-icon>{{ item.title }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" elevation="1">
        <v-tab-item class="elevation-4 ma-5 rounded">
          <h3 class="ms-5 mt-5 indigo--text">Where do you want to go ?</h3>
          <flightSearch @scrollNow="scrollNow"/>
        </v-tab-item>
        <!-- <v-tab-item>
          <hotelSearch @scrollNow="scrollNow"/>
        </v-tab-item>
        <v-tab-item>
          <carSearch @scrollNow="scrollNow"/>
        </v-tab-item> -->
      </v-tabs-items>
    </v-card>

    <flightResults style="transform: translateY(-150px);" v-if="$store.state.showFlightResults && tab === 0" />
    <!-- <hotelsResults style="transform: translateY(-150px);" v-if="$store.state.showHotelResults && tab === 1"/> -->
    <!-- <oneHotel style="transform: translateY(-150px);" v-if="$store.state.showOneHotel && tab === 1"/> -->
    <!-- <carsResults style="transform: translateY(-150px);" v-if="$store.state.showCarResults && tab === 2"/> -->
    <v-dialog persistent v-model="$store.state.showFlightBook" scrollable width="100%" style="position: relative;">
      <v-card class="pb-0" color="#f8f8f8">
      <v-card-title class="mb-5">
      <v-btn
      @click="$store.dispatch('setShowFlightBook', false)"
      icon
      absolute
      top
      left
      style="font-size: 40px; color: navy;"
      >
        &times;
        <!-- <v-icon color="indigo">mdi-close</v-icon> -->
      </v-btn>
      </v-card-title>
      <v-card-text class="mb-5">
      <book v-if="$store.state.showFlightBook"/>
      </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <v-dialog persistent v-model="$store.state.showCarBook" scrollable width="100%" style="position: relative;">
          <v-card class="pb-0">
          <v-card-title class="mb-5" background-color="#f8f8f8">
          <v-btn
          @click="$store.dispatch('setShowCarBook', false)"
          icon
          absolute
          top
          left
          >
            <v-icon color="indigo">mdi-close</v-icon>
          </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mb-0">
          <carBook v-if="$store.state.showCarBook"/>
          </v-card-text>
          </v-card>
    </v-dialog>
    <v-dialog persistent v-model="$store.state.showHotelBook" scrollable width="100%" style="position: relative;">
          <v-card class="pb-0">
          <v-card-title class="mb-5" background-color="#f8f8f8">
          <v-btn
          @click="$store.dispatch('setShowHotelBook', false)"
          icon
          absolute
          top
          left
          >
            <v-icon color="indigo">mdi-close</v-icon>
          </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mb-0">
          <hotelBook v-if="$store.state.showHotelBook"/>
          </v-card-text>
          </v-card>
    </v-dialog> -->
  </v-app>
  <V-app v-else style="height: 100vh;">
    <v-container>
      <login />
    </v-container>
  </V-app>
</template>

<script>
import flightSearch from './views/flights.vue'
import book from './views/book.vue'
import overlay from './components/overlay.vue'
import flightResults from './views/flightResults.vue'
import login from './views/login.vue'
import { mapState } from 'vuex'
import { headersAuth } from './links'
// import carSearch from './views/cars.vue'
// import hotelSearch from './views/hotels.vue'
// import carsResults from './views/carsResults.vue'
// import hotelsResults from './views/hotelsResults.vue'
// import carBook from './views/carBook.vue'
// import hotelBook from './views/hotelBook.vue'
// import oneHotel from './views/oneHotel.vue'
export default {
  name: 'App',
  components: {
    flightSearch,
    overlay,
    flightResults,
    book,
    login
    // carSearch,
    // carsResults,
    // carBook,
    // hotelSearch,
    // hotelsResults,
    // hotelBook,
    // oneHotel
  },
  data () {
    return {
      tab: null,
      snackbar: false,
      color: null,
      text: null,
      items: [
        { title: 'Flights', icon: 'mdi-airplane' }
        // { title: 'Hotels', icon: 'mdi-domain' },
        // { title: 'Cars', icon: 'mdi-car' }
      ]
    }
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    scrollNow () {
      const height = window.innerHeight
      this.$vuetify.goTo(height, { duration: 1000 })
    },
    logout () {
      const token = this.$store.state.user
      const header = { headers: headersAuth(token) }
      const body = ''
      this.$http.post('https://dev.atnbookingengine.com/api/user/logout', body, header).then(response => {
        console.log(response.data)
        if (response.data.status) {
          this.text = response.data.message
          this.color = 'success'
          this.snackbar = true
          this.$store.commit('setUser', null)
        } else {
          this.text = response.data.message
          this.color = 'error'
          this.snackbar = true
        }
      }).catch(err => {
        console.error(err)
        this.text = err.body.message
        this.color = 'error'
        this.snackbar = true
      })
    }
  },
  created () {
    this.$store.state.flightDates.departureDates = [null, null, null]
    this.$store.state.flightDates.arrivalDate = null
    this.$store.dispatch('setShowFlightResults', false)
    this.$store.dispatch('setShowFlightBook', false)
    this.$store.dispatch('clearFlightsSearchTimeoutFunction')
    this.$store.dispatch('clearFlightsTimeoutFunction')
    this.$store.dispatch('setFlightsTimeOut', false)
    this.$store.commit('setPaymentTab', 'reserve')
  }
}
</script>

<style>
  input {
    outline: none;
  }
  .tabs {
    margin-top: 20px;
    transform: translateY(-5px);
  }
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn, .theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
    color: rgb(161, 161, 161) !important;
  }
  .bg {
    background-color: transparent !important;
    /* min-height: 500px; */
  }
  .v-window__container {

    min-height:500px
}
  .v-window-item.v-window-item--active {
    background-color: #ffffff;
   }
  .v-window.v-item-group.theme--light.v-tabs-items {
    background-color: transparent;
  }
  .daterangepicker td.in-range {
    background-color: #93deff;
  }
  .daterangepicker td.active {
    background-color: #0086bf;
  }
  .dots-text:hover {
    background-color: rgb(230, 230, 230);
    color: blue;
  }
  @media screen and (max-width:945px) {
    .v-window__container {
      min-height:100vh;
    }
  }
</style>
